/** This file should be included in every page */

import en from './lang/en';
// import ro from './lang/ro';
import de from './lang/de';
// import hr from './lang/hr';
import { fetcher } from "./components/MVC/worldFetcher";
import AlertNotification from "./components/Modals/Notifications/AlertNotification";

class MultiLanguagesController {
  constructor() {
    this.languages = {
      en,
      de,
      // ro,
      // hr,
    }
    ///loop throug languages, us en as default and override it with language
    for (const lang of Object.keys(this.languages)) {
      if (lang !== 'en') {
        this.languages[lang] = { ...this.languages["en"], ...this.languages[lang] };
      }
    }
    this.language = 'en';
    this.languageObject = this.languages[this.language];
    this.supportedLanguages = Object.keys(this.languages);
    this.initialzed = false;
  }

  init() {
    if (!this.initialzed) {
      this.initialzed = true;
      this.getLanguageFromLocalStorage()
      this.getLanguage();
    }
  }

  renderLanguage() {
    const elements = document.querySelectorAll('[data-lang]');
    elements.forEach((element) => {
      const key = $(element).attr('data-lang');
      if (this.languages[this.language].hasOwnProperty(key)) {
        for (const [attr, val] of Object.entries(this.languages[this.language][key])) {
          switch (attr) {
            case 'text':
              $(element).text(val);
              break;
            case 'value':
              $(element).val(val);
              break;
            default:
              $(element).attr(attr, val);
          }
        }
      } else {
        $(element).attr("text", "no-translation");
      }
    });

    $('.language-option, .lang-selector__option').removeClass("active");
    $(`.language-option[data-lang=${this.language}], .lang-selector__option[data-lang=${this.language}]`).addClass("active");
  }

  changeLanguage = (lang, save = true) => {
    if (save && window.__forceWorldLanguageCode) {
      return;
    }
    if (this.languages.hasOwnProperty(lang)) {
      this.language = lang;
      this.languageObject = this.languages[this.language];

      const elements = document.querySelectorAll('[data-lang]');
      elements.forEach((element) => {
        const key = $(element).attr('data-lang');

        if (this.languages[lang].hasOwnProperty(key)) {
          for (const [attr, val] of Object.entries(this.languages[lang][key])) {
            switch (attr) {
              case 'text':
                $(element).text(val);
                break;
              case 'value':
                $(element).val(val);
                break;
              default:
                $(element).attr(attr, val);
            }
          }
        } else {
          $(element).attr("text", "no-translation");
        }
      });

      // Synchronize with backend using worldFetcher
      const localStorageLang = localStorage.getItem('language');
      if (localStorageLang !== lang) {
        this.saveLanguageToLocalStorage();
      }
      if (save) {
        fetcher.saveLanguage(lang,
          (response) => {
            // Reload page if user is on admin page
            if (window.location.pathname.startsWith('/admin')) {
              window.location.reload();
            }
          },
          (error) => {
            console.error('Error synchronizing language with backend:', error);
          }
        );
      }
    } else {
      const alertNotification = new AlertNotification({})

      alertNotification.createNotification({
        ...alertNotification.defaults,
        classType: 'error',
        text: this.languages[this.language]['error-language-support'].text,
        dataLang: 'error-language-support',
      })
    }
  }

  getLanguage = () => {
    if (window.__forceWorldLanguageCode && this.languages.hasOwnProperty(window.__forceWorldLanguageCode)) {
      this.changeLanguage(window.__forceWorldLanguageCode, false);
      this.renderLanguage();
      return;
    }

    // First try to get language from backend using worldFetcher
    fetcher.getLanguage(
      (response) => {
        if (window.__forceWorldLanguageCode && this.languages.hasOwnProperty(window.__forceWorldLanguageCode)) {
          this.changeLanguage(window.__forceWorldLanguageCode, false);
          this.renderLanguage();
          return;
        }

        if (response.data && response.data.success && response.data.language) {
          const backendLang = response.data.language;

          // If backend language is different from local storage, use backend language
          if (this.languages.hasOwnProperty(backendLang)) {
            this.changeLanguage(backendLang, false);
            this.renderLanguage(backendLang);
            return;
          }
        }

        // Fallback to local storage if backend request fails or returns invalid language
        this.getLanguageFromLocalStorage();
      },
      () => {
        // Fallback to local storage if backend request fails
        this.getLanguageFromLocalStorage();
      }
    );
  }

  saveLanguageToLocalStorage = () => {
    localStorage.setItem('language', this.language);
  }

  getLanguageFromLocalStorage = () => {
    if (window.__forceWorldLanguageCode && this.languages.hasOwnProperty(window.__forceWorldLanguageCode)) {
      this.changeLanguage(window.__forceWorldLanguageCode, false);
      this.renderLanguage();
      return;
    }

    if (localStorage.getItem('language')) {
      const lang = localStorage.getItem('language');

      if (this.languages.hasOwnProperty(lang)) {
        this.changeLanguage(lang, false);
        this.renderLanguage(lang);
      }
    }
  }
}

// public language controller to reduce needs for model
window.multiLanguagesController = new MultiLanguagesController();

/**
 * public a function to get translated text
 * @param {string} key
 * @param {object} replace
 * @param {string} defaultText text to return if key is not found in current language
 * @return {string}
 *
 * example:
 * if the key and value is "error-language-support": "The language {name} is not supported"
 * when use $trans('error-language-support', {name: 'John'})
 * {name} will be replaced with "John"
 * will return "The language John is not supported"
 */
window.$trans = (key, replace = {}, defaultText = null) => {
  let text = window.multiLanguagesController.languageObject[key]?.text || defaultText || key;

  if (text && typeof replace === 'object' && Object.keys(replace).length > 0) {
    for (const [key, value] of Object.entries(replace)) {
      text = text.replace(new RegExp(`{${key}}`, 'g'), value || '');
    }
  }

  return text;
}

// Always render languages when page is loaded
$(document).ready(() => {
  multiLanguagesController.init();
});

export default {
  en,
  de,
  // ro,
  // hr,
}
